import _ from 'lodash'

import {
  Bar,
  LoadingContainer,
  Panels,
  Breadcrumb,
  ListNav2,
} from 'peach/components'
import { useClickAction } from 'peach/decorators/withActionTrigger'
import { getName } from 'peach/helpers'
import { Switch, Route, useRouteMatch, useParams } from 'peach/router'

import { useLoanGet, useLoanRefresh } from 'core/types'

import LoanDrawRoutes from './LoanDraws/LoanDrawRoutes'
import LoanRoutes from './LoanRoutes'
import LoanTransaction from './LoanTransaction'

const Loan = () => {
  const { personId, loanId } = useParams<{
    personId?: string
    loanId?: string
  }>()

  const {
    data: loan,
    isLoading,
    error,
  } = useLoanGet({
    personId,
    loanId,
  })

  const { url, path } = useRouteMatch()

  const { mutateAsync: refreshLoan } = useLoanRefresh({
    personId,
    loanId,
  })

  const loanName = getName(loan)

  const title = loanName || (isLoading ? 'Loading…' : loanId)

  const syncLoan = async () => {
    await refreshLoan()
  }

  useClickAction({
    label: 'Sync Loan',
    onClick: syncLoan,
  })

  const header = <Bar title={title} />

  const isLOC = loan?.type === 'lineOfCredit'

  const items = _.compact([
    ['Loan', '', true],
    '/timeline',
    '/rates',
    '/transactions',
    '/expected-payments',
    '/obligations',
    '/balances',
    isLOC && '/draws',
    '/refunds',
    '/fees',
    '/documents',
    '/statements',
    '/periods',
    '/autopay',
    '/ledger',
    '/advances',
  ])

  const nav = <ListNav2 baseUrl={url} items={items} searchable />

  return (
    <>
      <Breadcrumb title={loanName} to={url} />
      <Switch>
        <Route path={`${path}/draws/:drawId`}>
          <Breadcrumb to={`${url}/draws`} />
          <LoanDrawRoutes />
        </Route>
        <Route>
          <Panels left={nav}>
            <Switch>
              <Route path={`${path}/transactions/:transactionId`}>
                <Breadcrumb to={`${url}/transactions`} />
                <LoanTransaction />
              </Route>
              <Route path={path}>
                <Panels header={header}>
                  <LoadingContainer error={error} isLoading={isLoading}>
                    <LoanRoutes />
                  </LoadingContainer>
                </Panels>
              </Route>
            </Switch>
          </Panels>
        </Route>
      </Switch>
    </>
  )
}

export default Loan
